import React, { Component } from 'react';
import { LeaveBookingFeedbackData } from 'AppClient/api/Bookings';
import styles from './styles.module.scss';
import { Form, TextArea, Icon, Rate } from 'components/antd';
import { FormComponentProps } from 'antd/lib/form';
import { ThemeContext } from 'app-themes';
import { AddressesView } from '../TripDetails/AddressesView';
import classNames from 'classnames';
import stylesRegards from '../NewBookingRegards/styles.module.scss';

interface Props {
    data: LeaveBookingFeedbackData;
    onChangeRating: (a: number) => number;
}

class LeaveBookingFeedbackForm extends Component<Props & FormComponentProps> {
	static contextType = ThemeContext;

	render() {
        const theme = this.context;
        const { data } = this.props;

		return (
			<Form layout="vertical" className={styles.feedbackForm} autoComplete="off">
                <div
                    className={classNames(stylesRegards.regards, {
                        [stylesRegards[`regards-${theme}`]]: theme !== '',
                    })}
                >
                    <div className={stylesRegards.regardsBookingNumber}>
                        Booking reference number:
                        <span> {data.bookingNumber}</span>
                    </div>

                    <div className="modalBox modalBoxBooking">
                        <div className="modalBoxRow">
                            <div className="modalBoxCol w12">
                                <div
                                    className={classNames(
                                        stylesRegards.regardsBox,
                                        stylesRegards.dateTime
                                    )}
                                >
                                    <Icon type="dateTimePicker" />
                                    <span className={stylesRegards.regardsUpComing}>{data.pickUpDateTime}</span>
                                </div>

                                <div
                                    className={classNames(
                                        stylesRegards.regardsBox,
                                        stylesRegards.rout
                                    )}
                                >
                                    <AddressesView addresses={data.addresses} />
                                </div>
                            </div>
                        </div>

                        <div className="modalBoxRow dark">
                            <div className="modalBoxCol w12">
                                <h5>Rate your trip with {data.servicePartnerName}</h5>
                                <Rate onChange={this.props.onChangeRating} allowClear={false} size="large" />
                                <h5 className={styles.ratingOptional}>
                                    Leave your feedback <span>• Upcoming feature •</span>
                                </h5>
                                <Form.Item>
                                    <TextArea className={styles.feedback} />
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                </div>
            </Form>
		);
	}
}

export default LeaveBookingFeedbackForm;
